export enum SuspensionStatus {

  NOT_SUSPENDED,
  PARTIAL,
  FULL

}
